<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Matchs">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-gamepad"></i> Match Tables
            </div>
            <div class="card-body">
              <div class="mb-3">
                <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()" tooltip="Add match table" placement="top">
                  <i class="fa fa-plus"></i> Add Match Table
                </button>
              </div>
              <table class="table table-responsive-sm table-hover table-outline mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Rank</th>
                    <th>Variant</th>
                    <th>Name</th>
                    <th>Min Level</th>
                    <th>Cost</th>
                    <th>XP Reward</th>
                    <th>LP Reward</th>
                    <th>Credits (W/L/D)</th>
                    <th>Hammers</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (matchTable of matchTables; track matchTable.matchTableId; let i = $index) {
                    <tr>
                      <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                      <td>{{ matchTable.matchTableId }}</td>
                      <td>{{ matchTable.matchRank }}</td>
                      <td>{{ matchTable.variantId }}</td>
                      <td>{{ matchTable.name }}</td>
                      <td>{{ matchTable.levelMinimumRequired }}</td>
                      <td>{{ matchTable.matchCost }}</td>
                      <td>{{ matchTable.levelExperienceRewardQuantity }}</td>
                      <td>{{ matchTable.leaguePointRewardQuantity }}</td>
                      <td>{{ matchTable.creditRewardQuantity1 }} / {{ matchTable.creditRewardQuantity2 }} / {{ matchTable.creditRewardQuantityDraw }}</td>
                      <td>{{ matchTable.hammerRewardQuantity }}</td>
                      <td>
                        <div class="btn-group me-1">
                          <button class="btn btn-sm btn-warning" type="button" (click)="onClickEdit(matchTable)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                        </div>
                        |
                        <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(matchTable)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <br/>
              <div class="d-flex justify-content-between align-items-center">
                <small class="text-muted">
                  Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + matchTables.length }} of {{ totalResults }} entries
                </small>
                <ul class="pagination pagination-sm mb-0">
                  <li class="page-item" [class.disabled]="pageNumber <= 1">
                    <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
                  </li>
                  @for (page of getPageNumbers(); track $index) {
                    @if (page === null) {
                      <li class="page-item disabled"><span class="page-link">...</span></li>
                    } @else {
                      <li class="page-item" [class.active]="page === pageNumber">
                        <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                      </li>
                    }
                  }
                  <li class="page-item" [class.disabled]="matchTables.length < resultsPerPage">
                    <button class="page-link" (click)="onClickPaginationNext()" [disabled]="matchTables.length < resultsPerPage">&raquo;</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </tab>
        <tab heading="Statistics" (selectTab)="onSelectStatisticsTab()">
          <app-matchs-statistics-tab #statisticsTab></app-matchs-statistics-tab>
        </tab>
      </tabset>
    </div>
  </div>
</div>

<app-match-table-add-modal #addModal></app-match-table-add-modal>
<app-match-table-edit-modal #editModal></app-match-table-edit-modal>
